import * as Sentry from '@sentry/react'
import jsbridge from "@xpeng/js-bridge";
import request from '../../../network/request'

/** APP返回的定位信息 */
export type TAppLocation = {
  code?: number; 
  data?: {
    adCode?: string;
    address?: string;
    cityCode?: string;
    coords?: { 
      latitude?: number;
      longitude?: number;
    }
  }
  
}

export function getLocationFromApp() {
  const timeout = 5000;
  return new Promise<TAppLocation>((resolve, reject) => {
    const timer = setTimeout(() => {
      const msg = 'jsbridge Call requestLocation time out.';
      Sentry.captureMessage(msg, {
        tags: { timeout }
      });
      reject(new Error(msg));
    }, timeout)

    jsbridge.callHandler("requestLocation", {}).then((res:TAppLocation) => {
      // 如果app端的定位在不允许下，需要手动抛出error(判断ios端res.code=2，Android端code=10)
      clearTimeout(timer);
      console.log(res, "手机原生定位信息~@~@~~@~@~@~@~@~@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
      if (res?.data?.coords?.longitude && res?.data?.coords?.latitude) {
        resolve(res);
      } else {
        reject();
        // console.log("获取定位失败", res.message, "\n 设置adCode为默认 DEFAULT_CITY_CODE", DEFAULT_CITY_CODE);
        // setLocationMsg({
        //   data: {
        //     adCode: DEFAULT_CITY_CODE,
        //   }
        // })
      }
    });
  })
};

// 获取服务省/城市列表
export async function getProvinceAndCity() {
  try {
    const provinceAndCity: any = await request(
      "service/provinceCity/list",
      {},
      "POST"
    );
    console.log("服务省/城市列表 >>>>>>>>>>>>>>>>>>>>>>>>>>> ", provinceAndCity);

    return provinceAndCity;
  } catch (err) {
    console.log((err as any).message, "获取服务省/城市列表失败提示信息");
    throw new Error(`${err}`);
  }
};